module.exports = ".control-label{\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n\r\nbody .has-error input.ui-inputtext{\r\n  border-color: rgb(201, 39, 39) !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cfc/cadastrar-termo-aditivo-cfc/cadastrar-termo-aditivo-cfc.component.css
// module id = ./src/app/components/cfc/cadastrar-termo-aditivo-cfc/cadastrar-termo-aditivo-cfc.component.css
// module chunks = main